<template>
  <div style="display: inline-block">
    <el-button
      @click="opendialog()"
      class="zj-lnglatselect-button"
      :disabled="disabled"
    ></el-button>
    <el-dialog
      v-dialogDrag
      class="poi-point-select-map"
      style="text-align: left"
      title="选择位置"
      :visible.sync="dialogVisible1"
      :modal="false"
    >
      <div class="map"></div>
    </el-dialog>
    <el-dialog
      title="选择的经纬度"
      style="text-align: left"
      :visible.sync="dialogVisible2"
      width="40rem"
      :before-close="handleClose"
      :modal="false"
    >
      <div>
        经度：{{ this.lng }}
        <br />
        纬度：{{ this.lat }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="onGotLngLat">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ZjLngLatSelect",
  props: {
    center: [],
    point_lat: String,
    point_lng: String,
    disabled: Boolean,
  },
  data() {
    return {
      toUrl: "/plugin/emergency/ui/onemap",
      loadingText: "加载中...",
      mapInstance: null,
      dialogVisible1: false,
      dialogVisible2: false,
      marker: null,
      lat: "",
      lng: "",
    };
  },
  mounted() {},
  methods: {
    opendialog: function () {
      console.log(this.point_lat);
      console.log(this.point_lng);
      this.marker = null;
      this.dialogVisible1 = true;
      this.onDrawMap();
    },
    onGotLngLat() {
      this.dialogVisible2 = false;
      this.dialogVisible1 = false;
      this.$emit("onGotLngLat", { lat: this.lat, lng: this.lng });
    },
    onDrawMap: function () {
      // 创建地图，并通过样式让地图填满窗口
      let that = this;
      this.$nextTick(function () {
        // eslint-disable-next-line no-undef
        $(function () {
          // 不传入 syscode 和 key ，或者值为空时，
          // zjumap 插件自动从 URL 地址
          // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
          // 中读取 syscode 和 key 的值。
          // eslint-disable-next-line no-undef
          $(".map").zjumap({
            syscode: "ZJMap",
            key: "EmergencyOneMap",
            loading: ".global-loading",
            loadingText: ".global-loading-text",
            //地图配置
            mapConfigs: {
              // mapStyle: "styles/darknight.json",
              togglePanelVisiable: false,
              mapLayers: "",
              reportGeo: true,
              onGotGeo: function (e) {
                e.handled = true;
                if (that.marker) {
                  that.marker.setPosition(
                    e.map.newPoint(e.point.lng, e.point.lat)
                  );
                } else {
                  //that.marker = that.addMarker(e.map, e.point);
                }
                that.addMarkerPoint(e.map, e.point);
                that.dialogVisible2 = true;
                that.lat = e.point.lat;
                that.lng = e.point.lng;
              },
              onMapCreated: function (e) {
                that.mapInstance = e.map;
                e.map.clearAll();
                that.center = e.map.config.center;
                if (that.point_lng && that.point_lat) {
                  var point = new BMap.Point(that.point_lng, that.point_lat);
                  that.addMarkerPoint(e.map, point);
                }
              },
            },
          });
        });
      });
    },
    addMarker: function (map, point) {
      if (!map) return null;
      this.marker = map.createOverlay(
        point,
        {
          url: "/lib/zjmap/Content/images/marker/flag.png",
          width: 48,
          height: 48,
          offsetX: 24,
          offsetY: 48,
        },
        null,
        {
          enableClicking: false,
        }
      );
      map.addOverlay(this.marker);
      return this.marker;
    },
    addMarkerPoint(map, point) {
      map.clearAll();
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
    },
  },
};
</script>
<style lang="scss" scoped>
.poi-point-select-map .map {
  height: 40rem;
  width: 100%;
}
.zj-lnglatselect-button {
  background-image: url("/img/geo.png");
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  width: 3.6rem;
  height: 3.6rem;
  background-size: cover;

  &:hover {
    background-color: rgba(61, 159, 255, 0.6);
  }
  &.is-disabled {
    background-color: rgba(204, 204, 204, 0.6);
    &:hover {
      background-image: url("/img/geo.png");
    }
  }
}
</style>